export default "__VITE_ASSET__DV5y2ScW__"